import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Global 401 interceptor: clears stale session and routes to /login,
// without breaking explicit auth endpoints (login / me / register / refresh).
let isRedirecting = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isAuthCheck =
      url.includes("/auth/login") ||
      url.includes("/auth/me") ||
      url.includes("/auth/register") ||
      url.includes("/auth/refresh");
    if (status === 401 && !isAuthCheck && !isRedirecting) {
      const path = window.location.pathname;
      // Only auto-redirect from protected app/admin routes.
      if (path.startsWith("/app")) {
        isRedirecting = true;
        // Fire-and-forget logout to clear cookies.
        try {
          api.post("/auth/logout").catch(() => {});
        } catch {}
        setTimeout(() => {
          window.location.href = "/login";
        }, 50);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
